














import { Component, Prop, Vue } from 'vue-property-decorator';
import { trackMixpanelBeacon } from "@utils/analytics";

@Component
export default class Modal extends Vue {
	mainNav: HTMLElement | null = document.getElementById('main-nav');
	mainContent: HTMLElement | null = document.getElementById('main-content');
	footer: HTMLElement | null = document.getElementById('footer');
	body: HTMLCollectionOf<HTMLBodyElement> = document.getElementsByTagName('body');

	@Prop()
	dataContext!: string;

	get mixpanelContext() : string {
		return this.dataContext ?? this.getModalName();
	}

	getModalName(): string {
		let parentModalName = this.$options.name;
		let parentComponent = this.$parent;

		for(let i = 0; i < 3; i++) {
			if(parentComponent) {
				if(parentComponent.$options.name?.includes('Modal')) {
					parentModalName = parentComponent.$options.name;
				}
				parentComponent = parentComponent.$parent;
			}
		}

		
		return parentModalName ?? 'Modal';
	}

	public measureScrollbarWidth(): number {
		const measuringDiv = document.createElement('div');
		measuringDiv.style.width = '100px';
		measuringDiv.style.height = '100px';
		measuringDiv.style.overflow = 'scroll';
		measuringDiv.style.position = 'absolute';
		measuringDiv.style.top = '-9999px';
		document.body.appendChild(measuringDiv);
		const scrollbarWidth = measuringDiv.offsetWidth - measuringDiv.clientWidth;
		document.body.removeChild(measuringDiv);
		const scrollbarVisible = window.innerHeight < document.body.scrollHeight;
		return scrollbarVisible ? scrollbarWidth : 0;
	}

	public close(): void {
		this.$emit('modal-close');
	}

	public created(): void {
		this.body = document.getElementsByTagName('body');
		const scrollbarWidth = this.measureScrollbarWidth() + 'px';

		if (this.mainContent) {
			this.mainContent.style.paddingRight = scrollbarWidth;
		}

		if (this.footer) {
			this.footer.style.paddingRight = scrollbarWidth;
		}

		if (this.mainNav) {
			this.mainNav.style.transition = 'none';
			this.mainNav.style.paddingRight = scrollbarWidth;
		}

		trackMixpanelBeacon('Web Modal Viewed', {
			'Modal' : this.mixpanelContext
		});
		
	}

	public destroyed(): void {
		if (this.body) {
			this.body[0].style.overflowY = 'hidden';
		}

		// first timeout waits until modal fade animation finishes to remove scrollbar padding
		setTimeout(() => {
			if (this.footer) {
				this.footer.style.paddingRight = '';
			}
			if (this.mainContent) {
				this.mainContent.style.paddingRight = '';
				if (this.body) {
					this.body[0].style.overflowY = '';
				}
			}
			if (this.mainNav) {
				this.mainNav.style.paddingRight = '';
			}

			//second timeout waits until nav transition animation finishes to remove inline transition, otherwise nav bounces
			setTimeout(() => {
				if (this.mainNav) {
					this.mainNav.style.transition = '';
				}
			}, 300);
		}, 500);
	}
}
